import {makeStyles} from "@material-ui/core/styles";
import {theme} from "../../../../../../shared/theme";
import {colors} from "../../../../../../shared/colors";

export default makeStyles({
    container: {
        backgroundColor: "#fdf2e3",
        padding: theme.spacing(1)
    },
    leftBox: {
        backgroundColor: "#ffffff",
        padding: theme.spacing(2),
        borderRadius: "10px",
        margin: "1em"
    },
    rightBox: {
        backgroundColor: colors.secondary.main,
        padding: theme.spacing(2),
        borderRadius: "10px",
        margin: "1em"
    }
});
